'use client';

import { useIntl } from 'react-intl';

export type CreatedDateProps = {
  createdDate: string;
};

/**
 * Shows created date formatted
 */

export const CreatedDate = ({ createdDate }: CreatedDateProps) => {
  const { formatDate } = useIntl();

  const [day, month, year] = createdDate.split('.');
  const date = new Date(`${year}-${month}-${day}`);

  return <span>{formatDate(date, { dateStyle: 'short' })}</span>;
};
